import { apiSlice } from "../apiSlice";

export const callbackApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCallbackRequest: builder.mutation({
      query: ({ data, token }) => ({
        url: `api/callback/create/`,
        method: "POST",
        body: data,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
});

export const { useCreateCallbackRequestMutation } = callbackApiSlice;
